import { UserPreferenceStore } from '@/store/UserPreferenceStore';
import { createContext } from 'react';

export const UserPreferenceContext = createContext<UserPreferenceStore>({} as any);
